export default __webpack_public_path__ + "static/media/pay-number.88fe3eb9.svg";